import React, { useContext } from "react";

import { TTip } from "@data-types/offer/event-row/EventRow";
import { EventContext } from "@gp/components";
import { EventKeyOffer } from "@gp/offer";
import { toDisplayOdd } from "@gp/utility";
import { useRootAppStore } from "@hooks";
import { BetBuilderModeContext } from "@state/context/bet-builder/BetBuilderModeContext";
import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import classNames from "classnames";
import { observer } from "mobx-react";

export const TipIndicatorButtonHoc = observer(
	function TipIndicatorButtonHoc(props: {
		buttonClasses: string;
		tip: TTip["tip"];
		eventKeyOffer?: EventKeyOffer;
	}) {
		const rootStore = useRootAppStore();
		const offerStore = useOfferContext();

		const event = useContext(EventContext);
		const isBetBuilderTab = useContext(BetBuilderModeContext);

		const {
			betBuilderStore: { nextOddsOff },
			betSlipStore: {
				betSlipState: {
					isMultiOfferEventPresent,
					isMultiOfferSelected,
				},
			},
		} = rootStore;

		const isSelected =
			rootStore.betSlipStore.betSlipState.clickedTips.length < 1
				? false
				: isBetBuilderTab
					? rootStore.betSlipStore.betSlipState.isMultiOfferSelected(
							event?.id,
							props.tip?.id
						)
					: rootStore.betSlipStore.isTipSelected(props.tip?.id || "");

		const isLocked =
			!isSelected &&
			(event?.isLocked ||
				props.eventKeyOffer?.isLocked ||
				props.tip?.isLocked);

		let isBetBuilderTipHidden = false;
		let isBetBuilderTipSelected = false;
		let betBuilderAvailableTip = null;

		//@ts-expect-error
		if (offerStore.betBuilderAvailableTips) {
			//@ts-expect-error
			betBuilderAvailableTip = offerStore.betBuilderAvailableTips.get(
				props.tip?.id
			);

			if (isBetBuilderTab) {
				//@ts-expect-error
				if (isMultiOfferEventPresent(offerStore.event.id)) {
					if (
						isMultiOfferSelected(props.tip?.eventId, props.tip?.id)
					) {
						isBetBuilderTipSelected = true;
					} else if (!nextOddsOff) {
						if (betBuilderAvailableTip) {
							isBetBuilderTipHidden = false;
						} else {
							isBetBuilderTipHidden = true;
						}
					}
				} else {
					isBetBuilderTipHidden = false;
				}
			}
		}

		const displayValue = toDisplayOdd(props.tip?.value || 0);
		const tipValue =
			isBetBuilderTab && betBuilderAvailableTip && !nextOddsOff
				? toDisplayOdd(betBuilderAvailableTip.providerValue)
				: displayValue;

		const buttonClasses = classNames(props.buttonClasses, {
			"one-click": rootStore.betSlipStore.isOneClickBetActive,
			"is-active": isSelected,
			desc: props.tip?.indicator === -1,
			inc: props.tip?.indicator === 1,
			"quota--dynamic": isBetBuilderTab && !nextOddsOff,
			"quota--static": isBetBuilderTab && nextOddsOff,
		});

		return (
			<button
				type="button"
				title={props.tip?.displayTip}
				onClick={() => {
					if (
						!rootStore.betSlipStore.isOneClickBetActive &&
						isBetBuilderTab
					) {
						rootStore.betBuilderStore.updateQuotaAndSetAvailableOffers(
							props.tip,
							event
						);
					} else {
						rootStore.betSlipStore.addRemoveOffer(props.tip);
					}
				}}
				disabled={isLocked || isBetBuilderTipHidden}
				className={buttonClasses}
			>
				{nextOddsOff ? (
					tipValue
				) : isBetBuilderTipSelected ? (
					<i className="u-icon u-icon--sml u-icon--check u-color--core--snow u-icon--animated--bounce-in" />
				) : isBetBuilderTipHidden && !isLocked ? (
					<i className="u-icon u-icon--sml u-icon--lock u-color--text--tertiary u-icon--animated--bounce-in" />
				) : (
					tipValue
				)}
			</button>
		);
	}
);
